import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import Seo from "../../components/head"
import Layout from "../../components/layout"
import Contest from "../../components/organisms/contest"

const ContestPage = ({ data, pageContext }) => (
  <Layout color={data.sanityContest.color}>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}>
      <Contest
        contest={data.sanityContest}
        finePrint={
          data.sanityContest.fine_print_override
            ? data.sanityContest.custom_fine_print
            : pageContext.finePrint
        }
        settings={data.sanitySettings}
      />
    </GoogleReCaptchaProvider>
  </Layout>
)

ContestPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default ContestPage

const HeadComponent = ({ data, location }) => (
  <Seo
    title={data.sanityContest.name}
    path={location.pathname}
    description={data.sanityContest.abstract}
    image={`${data.site.siteMetadata.siteUrl}${data.sanityContest.image.asset.publicUrl}`}
  />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const contestQuery = graphql`
  query contestQuery($id: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    sanitySettings {
      contest_conditions
      contest_closed
      contest_closed_after
    }
    sanityContest(id: { eq: $id }) {
      thank_you_title
      winner_date
      cm_id
      _rawThankYouMessage
      submit_cta
      start_date
      _rawClosedMessage
      end_date
      fine_print_override
      custom_fine_print
      additional_fields {
        name
        slug {
          current
        }
        type
        values
        min
        max
      }
      image {
        ...ImageWithPreview
        asset {
          publicUrl
        }
      }
      name
      partners {
        type
        url
        partner {
          logo {
            ...ImageWithPreview
          }
          dark_logo {
            ...ImageWithPreview
          }
          name
        }
      }
      color
      country {
        abbreviation
      }
      abstract
      id
      slug {
        current
      }
      _rawDetails
    }
  }
`
